import { getSchema as getSchema1, uiSchema as uiSchema1, } from "./schema.forgotPassword.1";
// eslint-disable-next-line import/no-default-export
export default (function () { return [
    {
        schema: getSchema1({}),
        uiSchema: uiSchema1(),
    },
]; });
